import React, { useContext, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { ApplicationContext } from "@context/ApplicationContext";
import { CheckoutComplimentaryContext } from "@context/CheckoutComplimentaryContext";
import AcknowledgementOfCountry from "@components/AcknowledgementOfCountry";
import PoweredBy from "@components/PoweredBy";
import "./style.scss";

const Legal = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const { isSubmitting } = useContext(CheckoutComplimentaryContext);
    const location = useLocation();

    const pageTextColor = useMemo(() => {
        if (location.pathname === "/welcome") {
            return whiteLabel?.subscriber_group?.subscriber_group_welcome_page?.page_text_color;
        } if (location.pathname === "/lets-get-started") {
            return whiteLabel?.subscriber_group?.subscriber_group_get_started?.page_text_color;
        }
        return null;
    }, [location.pathname, whiteLabel]);

    const linkStyle = pageTextColor ? { color: pageTextColor } : {};

    const formSubmitting = isSubmitting === true ? "legal__container--disabled" : "";

    let termsLink = null;
    let participatingCinemaLink = null;
    let privacyLink = null;
    let faqLink = null;
    let privacyCollectionNotice = null;
    let voucherTerms = null;

    if (whiteLabel?.terms_use_api === true) {
        termsLink = (
            <Link
                className="legal__link"
                to="/terms"
                style={linkStyle}
            >
                Terms &amp; Conditions
            </Link>
        );
    }

    if (whiteLabel?.privacy_use_api === true) {
        privacyLink = (
            <Link
                className="legal__link"
                to="/privacy"
                style={linkStyle}
            >
                Privacy Policy
            </Link>
        );
    }

    if (whiteLabel?.show_participating_cinemas === true) {
        participatingCinemaLink = (
            <Link
                className="legal__link"
                to="/participating-cinemas"
                style={linkStyle}
            >
                Participating Cinemas
            </Link>
        );
    }

    if (whiteLabel?.faq_use_api === true) {
        faqLink = (
            <Link
                className="legal__link"
                to="/faqs"
                style={linkStyle}
            >
                FAQs
            </Link>
        );
    }

    if (whiteLabel?.data_collection_use_api === true) {
        privacyCollectionNotice = (
            <Link
                className="legal__link"
                to="/privacy-collection-notice"
                style={linkStyle}
            >
                Privacy Collection Notice
            </Link>
        );
    }

    if (whiteLabel?.voucher_terms_api === true) {
        voucherTerms = (
            <Link
                className="legal__link"
                to="/voucher-terms"
                style={linkStyle}
            >
                Voucher T & Cs
            </Link>
        );
    }

    return (
        <>
            <div className={`legal__container ${formSubmitting}`}>
                {termsLink}
                {privacyLink}
                <a
                    className="legal__link"
                    href={`mailto:${whiteLabel?.support_email}`}
                    style={linkStyle}
                >
                    Contact Us
                </a>
                {participatingCinemaLink}
                {faqLink}
                {privacyCollectionNotice}
                {voucherTerms}
            </div>
            <PoweredBy />
            <AcknowledgementOfCountry />
        </>
    );
};

export default Legal;
